import { createFileRoute } from '@tanstack/react-router';
import {
  cachedApprovedOrganization,
  eventRacesQuery,
  interestedCountQuery,
  organizationEventQuery,
} from '@/features/organizer/api';
import { EventPage } from '@/features/organizer/pages/EventPage';

export const Route = createFileRoute('/_authed/org/$organizationId/events/$eventId/')({
  staticData: { help: 'event' },
  loader: ({ context: { queryClient }, params }) => {
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (!organization) return;
    void queryClient.prefetchQuery(organizationEventQuery(organization, params.eventId));
    void queryClient.prefetchQuery(eventRacesQuery(organization, params.eventId));
    void queryClient.prefetchQuery(interestedCountQuery(organization, params.eventId));
  },
  component: EventRoute,
});

function EventRoute() {
  const { eventId } = Route.useParams();
  return <EventPage eventId={eventId} />;
}
